<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<app-breadcrumb></app-breadcrumb>

<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<br>

<div class="position-relative grid-content">
    <div>
        <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center px-3"></div>
            <div class="d-flex gap-3">
                <div id="header-container" *ngIf="printers.length">
                    <div class="search-container">
                        <span class="fa fa-search form-control-feedback"></span>
                        <input type="text" class="form-control search_input" style="font-size: 12px"
                            placeholder="Search here..." (input)="globalFilter($event)" [(ngModel)]="searchValue" />
                    </div>
                </div>

                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" 
                    style="background-color: #0b6394;" (click)="openPrintLogsPopup()" (keydown.enter)="openPrintLogsPopup()">
                    <i class="fa fa-history text-white" style="font-size:16px;"></i>
                    <span class="reload_text text-white">Print Logs</span>
                </div>

                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" 
                    (click)="openAddPopup()" (keydown.enter)="openAddPopup()">
                    <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
                    <span class="reload_text text-white">Add New</span>
                </div>

                <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center" 
                    (click)="refreshGrid()" (keydown.enter)="refreshGrid()" *ngIf="printers.length">
                    <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
                    <span class="reload_text">Reload</span>
                </div>
            </div>
        </div>
    </div>

    <div class="table-container" *ngIf="printers.length">
        <table class="dynamic-table-container" aria-describedby="printers-table">
            <thead>
                <th style="min-width:50px;text-align:center"><span>#</span></th>
                <th class="grid-header-container" *ngFor="let col of columns" [ngStyle]="{'min-width': col.width}">
                    <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>{{ col.label }}</span>
                        <div (click)="sortColumn(col.key)" (keydown.enter)="sortColumn(col.key)">
                            <img class="cursor-click" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                        </div>
                    </div>
                </th>
                <th class="sticky-col first-col"></th>
            </thead>
            <tbody>
                <tr>
                    <td></td>
                    <td *ngFor="let col of columns" [ngStyle]="{'min-width': col.width}">
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search" (input)="columnFilter(col.key, $event)" />
                        </div>
                    </td>
                    <td></td>
                </tr>
                <tr *ngFor="let printer of pagedItems; let idx = index">
                    <td style="text-align:center;">{{ (pager.currentPage - 1) * perPage + idx + 1 }}</td>
                    <td class="sticky-dynamic-row1" style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">{{ printer.printerName }}</td>
                    <td class="sticky-dynamic-row1" style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">{{ printer.displayPrinterName || '-' }}</td>
                    <td class="sticky-dynamic-row1">{{ printer.ipAddress }}</td>
                    <td class="sticky-dynamic-row1">{{ printer.siteId || '-' }}</td>
                    <td class="sticky-dynamic-row1" style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">{{ printer.printerLocation || '-' }}</td>
                    <td class="sticky-dynamic-row1">
                        <span [ngStyle]="{ 'color': printer.isActive === 'Y' ? 'green' : 'red', 'font-weight': '600'}">{{ printer.isActive === 'Y' ? 'Active' : 'Inactive' }}</span>
                    </td>
                    <td class="sticky-dynamic-row1">{{ printer.createdOn | date:'dd-MMM-yyyy' }}</td>
                    <td class="sticky-col first-col">
                        <div class="action-icons">
                            <i class="fa-solid fa-pencil" (click)="openEditPopup(printer)"></i>
                            <i class="fa-sharp fa-solid fa-trash" (click)="openDeletePopup(printer)"></i>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="d-flex justify-content-center">
            <div class="width-cheat small paginationCell">
                <div class="d-flex align-items-center gap-3">
                    <div class="pagination_text mt-3">
                        Showing rows 1-{{ perPage }} of {{ printers.length | number }}
                    </div>
                    <div>
                        <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" 
                            [disabled]="false" [collectionSize]="pager.totalItems"
                            [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage"
                            [ellipses]="false" [boundaryLinks]="true" size="sm">
                        </ngb-pagination>
                    </div>
                    <div ngbDropdown class="mt-3">
                        <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
                            {{ perPage }} <i class="ms-1 fa-solid fa-chevron-down"></i>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                        </div>
                        per page
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!printers.length && !isProcessing" class="d-flex justify-content-center align-items-center" 
        style="min-height:200px;color:#888;font-size:14px">
        No approved printers found within the active session domain network context.
    </div>
</div>

<ng-template #addAndEditPopup>
    <div class="ng-template-container">
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="closeAddEditPopup()" mat-button>
            <i class="fa popupClose">&#xf00d;</i>
        </button>
        <div mat-dialog-title>
            <label for="title" class="popupTitle">{{ popupTitle }}</label>
            <label for="app-name" class="popupAppTitle">One<span style="color:gold">QMS</span></label>
        </div>

        <div class="form-continer">
            <div class="row">
                <div class="col-md-4">
                    <div>
                        <label id="printer-name">Printer Registry Name</label>
                        <span class="mandatory-symbol">*</span>
                    </div>
                    <input class="input-filed-continers" type="text" [(ngModel)]="primObj.printerName"
                        placeholder="ONEQMS-PHARMA-01" (ngModelChange)="onNgModelChange($event, 'printer-name')">
                </div>

                <div class="col-md-4">
                    <div><label id="display-name">Alias Display Name</label></div>
                    <input class="input-filed-continers" type="text" [(ngModel)]="primObj.displayPrinterName"
                        placeholder="Dispensary Label Printer">
                </div>

                <div class="col-md-4">
                    <div>
                        <label id="ip-address">IPv4 Network Host Address</label>
                        <span class="mandatory-symbol">*</span>
                    </div>
                    <input class="input-filed-continers" type="text" [(ngModel)]="primObj.ipAddress"
                        placeholder="192.168.1.45" (ngModelChange)="onNgModelChange($event, 'ip-address')">
                </div>
                <div class="col-md-4 mt-3">
                    <div>
                        <label id="site-id">Target Site Assignment Key ID</label>
                        <span class="mandatory-symbol">*</span>
                    </div>
                    <input class="input-filed-continers" type="text" [(ngModel)]="primObj.siteId"
                        placeholder="SITE_ASTAKENIS_01" (ngModelChange)="onNgModelChange($event, 'site-id')">
                </div>
                <div class="col-md-4 mt-3">
                    <div>
                        <label id="printer-location"><span class="mandatory-symbol">*</span>Physical Facility Location Description</label>
                    </div>
                    <input class="input-filed-continers" type="text" [(ngModel)]="primObj.printerLocation"
                        placeholder="Floor 2 - Sterile Block Dispensary Bay">
                </div>

                <div class="col-md-4 mt-3">
                    <div><label>Device Network Operational State</label></div>
                    <mat-slide-toggle color="primary" [(ngModel)]="primObj.isActiveBool">
                        <ng-container *ngIf="primObj.isActiveBool; else inactiveLabel">
                            <span class="active-inActive-container" style="color:rgb(43,227,43)">Active Verified</span>
                        </ng-container>
                        <ng-template #inactiveLabel><span style="color:red">Suspended</span></ng-template>
                    </mat-slide-toggle>
                </div>

                <div class="col-md-12 mt-3" *ngIf="visibleEditButton">
                    <div>
                        <label id="update-reason">Compliance Audit Reason for Specification Update</label>
                        <span class="mandatory-symbol">*</span>
                    </div>
                    <textarea class="input-filed-textarea" rows="3" cols="50" [(ngModel)]="primObj.updateReason"
                        (ngModelChange)="onNgModelChange($event, 'update-reason')" placeholder="Provide formal justification entries here..."></textarea>
                </div>
            </div>

            <div class="info-hint mt-3">
                <i class="fas fa-info-circle"></i> &nbsp;
                <strong>Printer Validation Parameter Extraction Help:</strong> Navigate via Windows Desktop context to: Control Panel &rarr; Devices and Printers &rarr; Right-Click &rarr; Printer Properties. Ensure the name string matches exactly to ensure network loop translation passes checks.
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" 
            (click)="saveFunction()" (keydown.enter)="saveFunction()" *ngIf="visibleAddButton">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Save Configuration</span>
        </div>

        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" 
            (click)="saveFunction()" (keydown.enter)="saveFunction()" *ngIf="visibleEditButton">
            <i class="fas fa-user-edit" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">Commit Changes</span>
        </div>

        <button mat-stroked-button class="cancelButton" (click)="closeAddEditPopup()">
            <i class="fa fa-close"></i> Abort
        </button>
    </div>
</ng-template>

<ng-template #deletePopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeDeletePopup()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle">{{ popupTitle }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold">QMS</span></label>
    </div>

    <div style="margin:15px 15px">
        <div class="row">
            <div class="col-md-12">
                <div>
                    <label id="delete-reason">Justification Reason for Database Device Purge Execution</label>
                    <span class="mandatory-symbol">*</span>
                </div>
                <textarea class="input-filed-textarea" rows="4" cols="50" [(ngModel)]="primObj.deleteReason"
                    (ngModelChange)="onNgModelChange(primObj.deleteReason, 'delete-reason')" placeholder="Enter mandatory regulatory cleanup reason statements..."></textarea>
            </div>
        </div>

        <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" 
                (click)="deleteFunction()" (keydown.enter)="deleteFunction()">
                <i class="fa fa-trash" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Purge Record</span>
            </div>
            <button mat-stroked-button class="cancelButton" (click)="closeDeletePopup()">
                <i class="fa fa-close"></i> Terminate
            </button>
        </div>
    </div>
</ng-template>

<ng-template #printLogsPopup>
    <div class="ng-template-container" style="height: 100%; display: flex; flex-direction: column; padding: 0px 0px 10px 0px;">
        
        <div mat-dialog-title class="d-flex justify-content-between align-items-center w-100 no-border-bottom" style="margin-bottom: 15px;">
            <div>
                <label class="popupTitle">Organization Audit Print Logs View</label>
                <label class="popupAppTitle">One<span style="color:gold;">QMS</span></label>
            </div>
            <button class="close close-button m-0 p-0" (click)="closePrintLogsPopup()" mat-button style="min-width: auto; line-height: normal;">
                <i class="fa popupClose" style="font-size: 18px;">&#xf00d;</i>
            </button>
        </div>

        <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
            <div>
                <div class="search-container">
                    <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search Log Data..."
                        [(ngModel)]="logSearchValue" (input)="logGlobalFilter($event)">
                </div>
            </div>
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" *ngIf="message.dataGridAdmin"
                (click)="openLogReorder()" (keydown.enter)="openLogReorder()">
                <i class="fa fa-cog text-white"></i>
                <span class="reload_text text-white">Settings</span>
            </div>
            <div>
                <div class="d-flex gap-2 action-buttons-container">
                    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                        (click)="openLogReport('Excel')" (keydown.enter)="openLogReport('Excel')">
                        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                        <span class="reload_text text-white">Excel Report</span>
                    </div>
                    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                        (keydown.enter)="openLogReport('Pdf')" (click)="openLogReport('Pdf')">
                        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                        <span class="reload_text text-white">PDF Report</span>
                    </div>
                    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                        *ngIf="message.isAuditTrailUser" (click)="openLogAuditTrail('overAll', 0)" (keydown.enter)="openLogAuditTrail('overAll', 0)">
                        <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
                        <span class="reload_text text-white">Audit Trail</span>
                    </div>
                    <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
                        (click)="getPrintLogsPopup()" (keydown.enter)="getPrintLogsPopup()" matTooltip="Refresh Grid Data">
                        <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
                        <span class="reload_text">Reload</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="table-container flex-grow-1" style="overflow: auto;">
            <table class="dynamic-table-container documentTable w-100">
                <thead>
                    <tr>
                        <th style="min-width: 60px; text-align: center;" [class]="logMakeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                            <div class="d-flex">
                                <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                            </div>
                        </th>
                        <th *ngFor="let logCol of logColumnLists.fieldColumnarray; let ix = index;"
                            [ngStyle]="{'min-width': logCol.width, 'max-width': logCol.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
                            class="sticky-dynamic-col1-log" (mouseover)="logCssFunction(ix)">
                            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                                <span>{{ logDynamicLabel ? logDynamicLabel[logColumnLists.columnsListarray[ix]] : logCol.fieldColumnarray }}</span>
                                <div (click)="logSortColumn(logColumnLists.columnsListarray[ix], logCol)">
                                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                                </div>
                            </div>
                        </th>
                        <th class="sticky-col first-col"></th>
                    </tr>
                    <tr>
                        <td [class]="logMakeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : ''"></td>
                        <td *ngFor="let logCol of logColumnLists.fieldColumnarray; let ix = index;" class="sticky-dynamic-col1-log">
                            <div class="row-search-container">
                                <input type="text" class="form-control" placeholder="Search"
                                    (input)="logColumnSearch(logColumnLists.columnsListarray[ix], $event, logColumnLists.columnsListarray1[ix]?.dataType === 'DATE' ? 'd' : 's')">
                            </div>
                        </td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let rowData of logPagedItems; let idx = index;" [class.highlightRow]="rowData.childCheckBoxs == true">
                        <td style="min-width: 60px; text-align: center;" [class]="logMakeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                            <div class="d-flex">
                                <div [ngClass]="rowData.childCheckBoxs ? 'static_icon' : 'hover-menu-icons'">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                                <input type="checkbox" style="zoom: 1.2;" [checked]="rowData.childCheckBoxs" (change)="logChildCheckBoxChecked($event, rowData, idx)">
                            </div>
                        </td>
                        <td *ngFor="let key of logColumnLists.columnsListarray1; let i = index;" class="sticky-dynamic-row1-log" (mouseover)="logCssFunction(i)"
                            [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                            
                            <span *ngIf="key.dataType == 'CHECKBOX'">
                                <div class="gridCheckBoxes">
                                    <img *ngIf="rowData[key.columnsListarray]" src="../../../assets/img/cr_module/accessSymbol.svg" width="16" height="16" alt="access" />
                                    <img *ngIf="rowData[key.columnsListarray] == false" src="../../../assets/img/cr_module/noAcessSymbol.svg" width="16" height="16" alt="no access" />
                                </div>
                            </span>

                            <span *ngIf="key.dataType == 'CLOB'">
                                <div class="download-button-continer btn-align" mat-dialog-actions>
                                    <button class="d-flex align-items-center downloadButton" mat-stroked-button (click)="getClobData(rowData, key.columnsListarray, $event)">
                                        <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                                        <span class="ms-1">View</span>
                                    </button>
                                </div>
                            </span>

                            <span *ngIf="key.dataType != 'CHECKBOX' && key.dataType != 'DATE' && key.dataType != 'CLOB'">
                                {{ rowData[key.columnsListarray] }}
                            </span>

                            <span *ngIf="key.dataType == 'DATE'">
                                {{ rowData[key.columnsListarray] | date:'dd-MMM-yyyy HH:mm' }}
                            </span>
                        </td>
                        <td class="sticky-col first-col">
                            <div class="action-icons">
                                <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20" height="20"
                                    src="../../assets/img/trail-individual.svg" (click)="openLogAuditTrail('individual', rowData)" />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="d-flex justify-content-center mt-3">
            <div class="width-cheat small paginationCell">
                <div class="d-flex align-items-center gap-3">
                    <div class="pagination_text mt-3">
                        Showing logs {{ logPager.startIndex + 1 }}-{{ logPager.endIndex + 1 }} of {{ logCollectionSize | number }}
                    </div>
                    <div>
                        <ngb-pagination class="leftpadding" (pageChange)="setLogPage(logPager.currentPage, $event)"
                            [collectionSize]="logPager.totalItems" [(page)]="logPager.currentPage" [maxSize]="maxSize" [rotate]="true"
                            [pageSize]="logPerPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                        </ngb-pagination>
                    </div>
                    <div ngbDropdown class="mt-3">
                        <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasicLog" ngbDropdownToggle>
                            {{ logPerPage }} <i class="ms-1 fa-solid fa-chevron-down"></i>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasicLog">
                            <button ngbDropdownItem (click)="logPaginationCall(10)">10</button>
                            <button ngbDropdownItem (click)="logPaginationCall(20)">20</button>
                            <button ngbDropdownItem (click)="logPaginationCall(50)">50</button>
                        </div>
                        per page
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #previewPopup>
<button class="close close-button" (click)="closePrintLogsPopup()">
    <i class="fa popupClose">&#xf00d;</i>
</button>
<div mat-dialog-title style="text-align: left;">
    <label class="popupTitle">Organization Audit Print Logs View</label>
    <label class="popupAppTitle">One<span style="color:gold;">QMS</span></label>
</div>
  <div class="ng-template-container" style="background-color: #f9f7f2; padding:15px; overflow:auto; max-height:500px;">
    <div [innerHTML]="previewData"></div>
  </div>
</ng-template>

<app-dynamic-audit-trail #auditTrailPopupLog></app-dynamic-audit-trail>
<app-excel-pdf #excelPdfPopupLog [excelPdf]="excelPdfLog"></app-excel-pdf>
<app-grid-reorder #gridReorderPopupLog (valueEmitter)="onLogChildValueEmitted()"></app-grid-reorder>